import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import TwoColumnLayout from '../../containers/two-column-layout';
//import OneColumnLayout from '../../blocks/one-column-layout';
//import ThreeColumnLayout from '../../blocks/three-column-layout';
//import FourColumnLayout from '../../blocks/four-column-layout';
import Photogallery from '../../blocks/photogallery';
import Presentation from '../../blocks/presentation';
import Slideshow from '../../blocks/slideshow';
import Slidegallery from '../../blocks/slidegallery';
import Promo from '../../containers/promo';
import Video from '../../blocks/video';
import Html from '../../containers/html';
import Wysiwyg from '../../containers/wysiwyg';

const TwoColumnLayoutBlock = props => <TwoColumnLayout {...props} />;
TwoColumnLayoutBlock.displayName = 'TwoColumnLayout';

export default withDynamicComponents({
  componentWhitelist: [
    //OneColumnLayout,
    //ThreeColumnLayout,
    //FourColumnLayout,
    Photogallery,
    Presentation,
    Slideshow,
    Slidegallery,
    Promo,
    Wysiwyg,
    Video,
    Html,
  ],
  mapInputToOutput: [
    ['firstContent', 'firstContent'],
    ['secondContent', 'secondContent'],
  ],
})(TwoColumnLayoutBlock);



// WEBPACK FOOTER //
// ./src/blocks/two-column-layout/index.jsx